import ProjectConfig from 'ProjectConfig';
import EnvironmentManager from 'Utils/environmentManager';

export const getSocketUrl = async () => {
  try {
    const socketUrl = EnvironmentManager.getMessageText({
      key: 'web_socket_url'
    });

    return socketUrl || ProjectConfig.WEBSOCKET_URL;

  } catch (e) {
    return ProjectConfig.WEBSOCKET_URL;
  }
};
